export default __webpack_public_path__ + "static/media/arrow-down-blak.fa0dcad4.svg";